import { BlocksIconHelp } from 'blocks-nextjs/blocks-web-components/components/icon/icons/help';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconHelp = createComponent({ react: React, tagName: 'cat-icon-help', elementClass: BlocksIconHelp });
